import { ProductionListPropertyDefinition } from '../properties/production-list-property-definition'

export class ColumnsConf {
  constructor(public columnDefinitions: ProductionListPropertyDefinition[]) {}
}
